const Index = r => require.ensure([], () => r(require('./Index')), 'group-complex')
const cSnapshotList = r => require.ensure([], () => r(require('./counselor/SnapshotList')), 'group-complex')
const cSnapshotDetails = r => require.ensure([], () => r(require('./counselor/SnapshotDetails')), 'group-complex')
const sSnapshotList = r => require.ensure([], () => r(require('./student/SnapshotList')), 'group-complex')
const sSnapshotDetails = r => require.ensure([], () => r(require('./student/SnapshotDetails')), 'group-complex')

export default{
  path: '/complex',
  component: Index,
  children: [
    {
      path: 'c/snapshot-list',
      name: 'cSnapshotList',
      component: cSnapshotList
    },
    {
      path: 'c/snapshot-details',
      name: 'cSnapshotDetails',
      component: cSnapshotDetails
    },
    {
      path: 's/snapshot-list',
      name: 'sSnapshotList',
      component: sSnapshotList
    },
    {
      path: 's/snapshot-details',
      name: 'sSnapshotDetails',
      component: sSnapshotDetails
    },
  ]
}
//http://localhost:8080/#/complex/c/snapshot-details?isApp=false&client=student&ordercode=T120286800829142016&productcode=P1065001190218132002&skucode=N106500119021813200201

//http://localhost:8080/#/student/unpaid-order-details?orderCode=T120308140829140759

//http://localhost:8080/#/complex/s/snapshot-list?ordercode=T120308140829140759&isApp=false&client=student

//http://localhost:8080/#/complex/s/snapshot-details?isApp=false&client=student&ordercode=T120308140829140759&productcode=P1010001190426184852




// WEBPACK FOOTER //
// ./src/components/complex/router.js